import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// SignupLogin page uses a page-scoped translation set only, matching
// the original base-branch behaviour. Platform stores these keys under
// the `SignupLogin:` prefix inside the react-locale module; the importer
// strips the prefix and writes them to `../locale/{lang}.json`.
const localeContext = require.context('../locale', false, /\.json$/);
const resources = {};
localeContext.keys().forEach((key) => {
  const lang = key.replace('./', '').replace('.json', '');
  resources[lang] = localeContext(key);
});

i18n.use(initReactI18next).init({
  resources,
  debug: process.env.NODE_ENV === 'development',
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  fallbackLng: 'en',
  initImmediate: false,
  lowerCaseLng: true,
});

export default i18n;
